module.exports = __webpack_public_path__ + "static/neon_claim_demo-0060739a0bef122e69e6cced85908f32.png";